import { gql } from '@apollo/client';
import Fragments from './fragments';

export const GENERIC_ENTITY_FLOWS_QUERY = gql`
  query genericEntityFlowsDictionary($context: String!) {
    genericEntityFlowsDictionary(context: $context) {
      id
      name
    }
  }
`;

export const GENERIC_ENTITY_BUSINESS_STATES_FLOW_QUERY = gql`
  query genericEntityBusinessStatesXFlow($flowId: ID!) {
    genericEntityBusinessStatesXFlow(flowId: $flowId) {
      id
      name
    }
  }
`;

export const CHECKLIST_QUERY = gql`
  query checklist($id: Int!) {
    checklist(id: $id) {
      ...checklistItem
      requiredDocumentFilters {
        ...checklistFilter
        filterValues {
          ...checklistFilterValue
        }
      }
      requiredDocumentProperties {
        ...checklistProperty
      }
      requiredDocTypeXUserGroups {
        ...checklistXUserGroupItem
      }
    }
  }
  ${Fragments.checklistItem}
  ${Fragments.checklistFilter}
  ${Fragments.checklistFilterValue}
  ${Fragments.checklistProperty}
  ${Fragments.checklistXUserGroupItem}
`;

export const CHECKLIST_PROPERTIES_QUERY = gql`
  query checklistProperties {
    checklistProperties {
      ...checklistPropertiesItem
    }
  }
  ${Fragments.checklistPropertiesItem}
`;

export const CHECKLIST_TYPES_QUERY = gql`
  query requiredDocTypes {
    requiredDocTypes {
      id
      name
      sharePointContentType
    }
  }
`;
